module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/profile_page/certification-83980b9c62ac62ccc7c913210c526534.png";